<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="ch00_fm02"></a><a id="page_3"></a><strong><big>300</big><br/>15-Minute<br/>Low-Carb Recipes</strong></h1>
<p class="subtitle">DELICIOUS MEALS THAT MAKE IT EASY TO LIVE YOUR LOW-CARB LIFESTYLE AND NEVER LOOK BACK</p>
<p class="author"><strong>Dana Carpender</strong><br/><span class="small">Author of <em>1001 LOW-CARB RECIPES</em></span></p>
<p class="images1"><img alt="Image" src="images/pub.jpg" width="50%"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02.vue?2bd5bf75